import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'
import {LinkExternalIcon} from '@primer/octicons-react'
import {Link} from '@primer/react'

import {LABELS} from '../constants/labels'
import {createIssueEventExternalUrl} from '../utils/urls'
import type {TransferredEventNode} from './issue-viewer-page-query-types'
import {TimelineRow} from './row/TimelineRow'
import styles from './TransferredEvent.module.css'

// RELAY-CLEANUP(TransferredEvent): widens nullable fields so still-Relay parent data is assignable.
// Remove when the timeline pagination fragments leave Relay.
export type TransferredEventFragment = RelayCompat<
  Pick<TransferredEventNode, 'actor' | 'createdAt' | 'databaseId' | 'fromRepository'>
>

type TransferredEventProps = {
  queryRef: TransferredEventFragment
  issueUrl: string
  onLinkClick?: (event: MouseEvent) => void
  highlightedEventId?: string
  refAttribute?: React.RefObject<HTMLLIElement | null>
}

export function TransferredEvent({
  queryRef,
  issueUrl,
  onLinkClick,
  highlightedEventId,
  refAttribute,
}: TransferredEventProps): React.ReactElement {
  const {actor, createdAt, fromRepository, databaseId} = queryRef

  const highlighted = String(databaseId) === highlightedEventId
  return (
    <TimelineRow
      highlighted={highlighted}
      refAttribute={refAttribute}
      actor={actor}
      createdAt={createdAt}
      deepLinkUrl={createIssueEventExternalUrl(issueUrl, databaseId)}
      onLinkClick={onLinkClick}
      leadingIcon={LinkExternalIcon}
    >
      <TimelineRow.Main>
        {LABELS.timeline.transferredThis}
        <Link href={`${fromRepository?.url}`} inline className={styles.Link}>
          {fromRepository?.nameWithOwner}
        </Link>
      </TimelineRow.Main>
    </TimelineRow>
  )
}
